import {
    fetchAllFlmRoutes,
    addMultipleFlmRoutes,
    updateMultipleFlmRoutes,
    generateSampleFlmRouteExcelForBulkAction,
    downloadFlmRoutes,
} from '@src/api/flmRouteMaster';

import {
    FLM_ROUTE_MASTER_PARAMS,
    FLM_ROUTE_MASTER_OBJECT_TYPE,   
} from '@src/components/pages/OpsDashboard/Setup/TransportModule/FlmRoute/FlmRouteMaster.constants';

const viewControl = {
    pageTitle: 'FLM Route Master',
    buckets: ['flmRouteMaster'],
    globalActions: [],
    downloadWithGlobalAppliedFilters: true,
    downloadOptions : [
        {
            key: 'download',
            title: 'Download Data',
            action: 'download',
        },
    ],
    fetchData: fetchAllFlmRoutes,
    downloadData: downloadFlmRoutes,
    add: {
        downloadSampleCsvFromApiCall: true,
        downloadSampleCsv: generateSampleFlmRouteExcelForBulkAction,
        title: 'Add FLM Routes',
        onBulkUpload: addMultipleFlmRoutes,
    },
    update: {
        downloadSampleCsvFromApiCall: true,
        downloadSampleCsv: generateSampleFlmRouteExcelForBulkAction,
        title: 'Update FLM Routes',
        onBulkUpload: updateMultipleFlmRoutes,
    },
    paramsForAddUpdate: [
      'Routes',
      'Route_List',
    ],
    params: FLM_ROUTE_MASTER_PARAMS,
    objectType: FLM_ROUTE_MASTER_OBJECT_TYPE,
    modalHeading: 'FLM Route Master',
    warningMsg: 'No Routes to upload',
    successMsg: 'FLM Routes Uploaded Successfully',
    updateMsg: 'FLM Routes Updated Successfully',
    failureArrayColumns: [
        {
            key: 'code',
            dataIndex: 'code',
            title: 'Route Code',
        },
        {
            key: 'error',
            dataIndex: 'error',
            title: 'Error',
        },
    ],
    bulkUploadMapping: null,
    sectionWiseForm: true,
    sectionLayout: 'horizontal',
    formItemColSpan: 16,
    formItemLayout: {
        labelCol: { span: 10 },
        wrapperCol: { span: 14 },
    },
    id: 'code',
    useDrawer: false,
    drawerWidth: '40%',
};

const buckets = {
    flmRouteMaster: {
        name: 'FLM Route Master',
        filters: [],
        actions: [],
    },
};

const bucketColor = {};

export default { viewControl, buckets, bucketColor };